import React, { useState, useRef } from 'react';
import styled from 'styled-components';
import TooltipHelp from '../../assets/icons/tooltip-helper.svg';
import { useOutsideClick } from '../../hooks';
import { isMobileDevice } from '../../helpers';
import TooltipBase from './TooltipBase';

const InformativeTooltip = ({
  children,
  dataPanel = 'generic-informative-tooltip',
  fixedPosition,
  backgroundColor
}) => {
  const [showTooltip, setShowTooltip] = useState(null);
  const ref = useRef(null);
  const hoverRef = useRef(null);
  const isMobile = isMobileDevice();

  useOutsideClick(ref, () => showTooltip && setShowTooltip(showTooltip === dataPanel));

  return (
    <ContentLayout
      onMouseEnter={() => !isMobile && setShowTooltip(true)}
      onMouseLeave={() => !isMobile && setShowTooltip(false)}
    >
      <img
        ref={hoverRef}
        src={TooltipHelp}
        alt='Signo de pregunta'
        onClick={() => setShowTooltip(dataPanel)}
        aria-hidden='true'
      />
      {showTooltip && (
        <TooltipBase
          ref={ref}
          hoverRef={hoverRef}
          show={showTooltip}
          withArrow
          dataPanel={dataPanel}
          position={fixedPosition || null}
          backgroundColor={backgroundColor}
        >
          {children}
        </TooltipBase>
      )}
    </ContentLayout>
  );
};

const ContentLayout = styled.div`
  display: flex;
  position: relative;
`;

export default InformativeTooltip;
